// Client-side mirror of `api/src/lib/password.ts`. The server remains
// authoritative; this exists only so the change-password form can show
// inline rule feedback that matches what the API will accept.

export const PASSWORD_MIN_LENGTH = 6;

const UPPER_RE = /[A-Z]/;
const LOWER_RE = /[a-z]/;
const DIGIT_RE = /[0-9]/;

export interface PasswordRuleResult {
  key: "length" | "uppercase" | "lowercase" | "digit";
  label: string;
  ok: boolean;
}

export function passwordRules(pw: string): PasswordRuleResult[] {
  const s = typeof pw === "string" ? pw : "";
  return [
    {
      key: "length",
      label: `At least ${PASSWORD_MIN_LENGTH} characters`,
      ok: s.length >= PASSWORD_MIN_LENGTH,
    },
    {
      key: "uppercase",
      label: "At least one uppercase letter (A-Z)",
      ok: UPPER_RE.test(s),
    },
    {
      key: "lowercase",
      label: "At least one lowercase letter (a-z)",
      ok: LOWER_RE.test(s),
    },
    {
      key: "digit",
      label: "At least one digit (0-9)",
      ok: DIGIT_RE.test(s),
    },
  ];
}

export interface PasswordValidationResult {
  ok: boolean;
  message?: string;
}

export function validatePassword(pw: string): PasswordValidationResult {
  const rules = passwordRules(pw);
  const failed = rules.find((r) => !r.ok);
  if (failed) {
    return { ok: false, message: `Password must satisfy: ${failed.label}.` };
  }
  return { ok: true };
}
